// extracted by mini-css-extract-plugin
export default {"answer":"interested_rows-module___answer___db6af594","row":"interested_rows-module___row___c3de5811","statement":"interested_rows-module___statement___c5c8cffa"};